import React, {useState} from 'react';
import {Button, Input, Modal} from 'antd';
import {getAgainHandler} from '../../store/TableRedux/TableRedux';
import {toast} from 'react-toastify';
import {useDispatch} from 'react-redux';
import Pallet from "../../http_request/Model/pallet/Pallet";


const NumberInPallet = ({data}) => {
    const [checked, setChecked] = useState(false);
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
     const [value, setValue] = useState(data.numberPerPallet)
    const handleShow = () => {

        setOpen(true);

    };


    const handleOk = () => {


        Pallet.request({
            beforeSend: () => {
                setLoading(true)
            }, success: (result) => {
                setChecked(!checked)
                setOpen(false)
                toast.success('تغییرات با موفقیت انجام شد.');
                dispatch(getAgainHandler())

            }, error: (error) => {
                toast.error(error.data.message);

            }, final: () => {
                setLoading(false)
            },


        }).addParams({'palletId': data.palletId, number: value}).numberPerPallet();


    };


    const handleCancel = () => {
        setOpen(false);
    };

    return (
        <>
            <div>
                <div className='py-1 px-4' onClick={handleShow}>تعداد کالا</div>

                <Modal
                    open={open}
                    title='تعداد کالا'
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[
                        <Button className='defBtn redBtn' key='back' onClick={handleCancel}>
                            انصراف
                        </Button>,
                        <Button className='defBtn blueBtn' key='submit' type='primary' loading={loading}
                                onClick={handleOk}>
                            ثبت
                        </Button>,

                    ]}
                >
                    <Input placeholder='تعداد کالا' type='number' value={value} onChange={(e) => {
                        setValue(e.target.value)
                    }}/>
                </Modal>
            </div>
        </>

    );
};
export default NumberInPallet;